module.exports = __webpack_public_path__ + "img/mini-error.91a389da.svg";